<template>
  <v-dialog
    :value="value"
    :max-width="dialogWidth"
    :fullscreen="isMobile()"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <v-card
      :height="cardHeight"
      width="100%"
      color="secondary"
    >
      <v-container>
        <v-row>
          <v-col cols="auto">
            <v-img src="../../assets/img/epi-use_dots.png" width="200px" contain/>
          </v-col>
          <v-spacer/>
          <v-col cols="auto">
            <v-btn icon color="white" @click="$emit('close')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row align="start" justify="start">
          <v-col>
            <v-img position="left" src="../../assets/img/geoclock_logo.png" height="50px" contain/>
          </v-col>
        </v-row>
      </v-container>

            <v-container>
                <v-row align="start" justify="start">
                    <v-card-text class="dialogText">
                      <p> {{ `${$t('dialogs.about.version')}: ${version}` }} </p>
                      <p> {{ `${$t('dialogs.about.licensedTo')}: ${licenseHolder}` }} </p>
                      <p> {{ `${$t('dialogs.about.activeUntil')}: ${licenseExpiryDate}` }} </p>
                      <p> {{ `${$t('dialogs.about.poweredBy')}: ` }}
                        <a href="http://epiuselabs.com/geoclock" target="_blank" class="dialogText">EPI-USE
                          Labs</a>
                      </p>
                    </v-card-text>
                </v-row>

            </v-container>
            <v-container class="bottom" style="bottom: 0; position: absolute;">

                <v-row>
                    <v-col>
                        <v-img position="left" src="../../assets/img/group_elephant_logo.png" height="40px" contain
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col align-self="end">
            <v-img
              position="right" src="../../assets/img/epi-use_labs_logo.png"
              height="40px"
              contain
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

import isMobile from '@/mixins/displayAdaptable';
import attachMobileBackButton from '@/mixins/attachMobileBackButton';

export default {
  name: 'AboutDialog',
  mixins: [attachMobileBackButton, isMobile],

  props: {
    value: Boolean,
  },

  computed: {
    ...mapState({
      licenseHolder: (state) => state.license.name,
      licenseExpiryDate: (state) => state.license.expiry_date,
      version: (state) => state.version,
    }),
    dialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'md':
        case 'lg': {
          return '50%';
        }
        case 'xl': {
          return '45%';
        }
        default: {
          return '100%';
        }
      }
    },

    cardHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': {
          return '750px';
        }
        default: {
          return '500px';
        }
      }
    },
  },
};
</script>

<style scoped>
.dialogText {
  color: white;
}
</style>
